import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import list from './sftp/api/list'
import remove from './sftp/api/remove'
import create from './sftp/api/create'
import update from './sftp/api/update'
import getStatus from './sftp/api/status'
import SFTP from './sftp/interface/sftpIntegration'
import dateService from 'live/services/date'
import Modal from './sftp/ModalEdition'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'
const ActionConfirmationDialog = require('live/components/actions/ui/confirmation-dialog')

const statusValid = (status: string): boolean => {
    if (!status || typeof status != 'string') return false
    return status.indexOf('still running') > -1
}

export default function SftpGroupDatabase() {
    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [deleteUid, setDeleteUid] = useState<string | undefined>()
    const [showModal, setShowModal] = useState<boolean>(false)
    const [sftpSelected, setSFTP] = useState<SFTP>()
    const [integrations, setIntegrations] = useState<SFTP[]>([])
    const [status, setStatus] = useState({})

    const updateList = () => {
        if (!loadingData) setLoadingData(true)
        list()
            .then(sftp => setIntegrations(sftp))
            .then(() => setLoadingData(false))
            .catch(() => setLoadingData(false))
    }
    useEffect(() => {
        updateList()
        getStatus().then(status => setStatus(status))
    }, [])
    const onSave = (sftp: SFTP) => {
        if (!sftp?.uid) {
            create(sftp).then(() => updateList())
        } else {
            update(sftp).then(() => updateList())
        }
    }

    return (
        <MainContainer>
            {loadingData ? (
                <LoadingIconCenter className="fa fa-spinner fa-spin fa-4x" aria-hidden="true"></LoadingIconCenter>
            ) : (
                <>
                    <ActionConfirmationDialog
                        show={!!deleteUid}
                        onHide={() => setDeleteUid(undefined)}
                        className={'modal-error modal-sm'}
                        content={`Remove Integration SFTP ${
                            integrations.filter(sftp => sftp.uid == deleteUid)[0]?.qualifierSFTP
                        }?`}
                        btnText={i18n('yes, remove')}
                        apply={() => {
                            remove(deleteUid).then(() => updateList())
                        }}
                    />
                    <SearchContainer>
                        <Button
                            data-cy="addNewGroup"
                            onClick={() =>
                                setSFTP({
                                    dateLastFile: new Date().getTime(),
                                    groupModels: {
                                        name: '',
                                        templates: [
                                            {
                                                databaseName: '',
                                                matchFileName: '',
                                                matchTabName: '',
                                                refDate: '',
                                                eventType: ''
                                            }
                                        ],
                                        timestamp: new Date().getTime()
                                    },
                                    qualifierSFTP: '',
                                    idSFTP: 0
                                })
                            }
                        >
                            <i className="fas fa-plus"></i>
                            <span>Add Group SFTP</span>
                        </Button>
                    </SearchContainer>
                    <Modal onSave={onSave} sftp={sftpSelected} onHide={() => setSFTP(undefined)} />
                    <Table>
                        <thead>
                            <tr>
                                <th>Qualifier</th>
                                <th>Number of Database</th>
                                <th>Last update</th>
                                <th>Status</th>
                                <th>{/* ACTIONS */}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {integrations.map(sftp => {
                                const statusSftp = statusValid(status[sftp.uid])

                                return (
                                    <tr key={sftp.qualifierSFTP}>
                                        <td>
                                            <span>{sftp.qualifierSFTP}</span>
                                        </td>
                                        <td>
                                            <span>{sftp.groupModels.templates.length}</span>
                                        </td>
                                        <td>
                                            <span>
                                                {dateService
                                                    .getMoment(new Date(Number(sftp.groupModels.timestamp)))
                                                    .format('dd/mm/yyyy, HH:MM:ss')}
                                            </span>
                                        </td>
                                        <td>
                                            <span>{statusSftp == true ? 'OK' : 'INVALID'}</span>
                                        </td>
                                        <td>
                                            <div>
                                                <LiveTooltip
                                                    className="table--column__live-tooltip"
                                                    hide={false}
                                                    position="top"
                                                    content={i18n('Edit integration')}
                                                >
                                                    <Icon
                                                        color="#37A3EF"
                                                        className="far fa-edit"
                                                        onClick={event => {
                                                            setSFTP(sftp)
                                                        }}
                                                    />
                                                </LiveTooltip>
                                                <LiveTooltip
                                                    className="table--column__live-tooltip"
                                                    hide={false}
                                                    position="top"
                                                    content={i18n('Delete integration')}
                                                >
                                                    <Icon
                                                        color="#d9534f"
                                                        className="far fa-trash-alt"
                                                        onClick={event => {
                                                            setDeleteUid(sftp.uid)
                                                        }}
                                                    />
                                                </LiveTooltip>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </>
            )}
        </MainContainer>
    )
}
const Table = styled.table`
    width: 100%;
    th,
    td {
        height: 48px;
        text-align: center;
    }
    th {
        color: var(--grey-700);
        color: #606a80;
        padding-bottom: 5px;
        font-style: normal;
        font-weight: 600;
    }
    tbody {
        tr {
            border-bottom: solid 1px #606a80;
            &:hover {
                background-color: var(--blue-200);
            }
        }
    }

    .edit-icon:hover {
        color: var(--blue-400);
    }
`
const FilterButton = styled.div`
    width: 30px;
    height: 32px;
    margin-left: 10px;
    color: #37a3ef;
    border: 1px solid var(--gray-400);
    border-radius: 2px;
    box-shadow: 0px 2px 2px var(--gray-400);
    display: flex;
    align-items: center;
    justify-content: center;
`

const MainContainer = styled.div`
    font-family: arial, sans-serif;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    position: relative;
    background-color: var(--gray-0);
    align-items: center;
    margin: auto;
    padding: 10px 10%;
`

const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: auto;
    height: 54px;
    width: 100%;
`

const Button = styled.button`
    width: 200px;
    margin-right: 10px;
    color: var(--gray-0);
    background-color: var(--blue-500);
    border: none;
    padding: 8px 0;
    border-radius: 3px;
    span {
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 16px;
        margin-left: 6px;
        color: var(--gray-0);
    }
    &:hover {
        color: var(--gray-0);
        background-color: var(--blue-400);
        border-color: var(--blue-700);
    }
`
const LoadingIconCenter = styled.i`
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 40px;
    color: ${props => props.color};
    margin-right: 1rem;
`
